module.exports = __webpack_public_path__ + "img/shangpin.9ec5f6ed.png";